import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour récupérer les données de la page About
export const getAboutPageData = async (locale) => {
  return getWithLocaleFallback("/about?populate[hero][populate]=*&populate[statsBlock]=*", {
    locale,
    fallbackLocale: 'fr'
  });
};

// Helper function to convert plain text to PortableText blocks
const convertPlainTextToPortableText = (plainText) => {
  if (!plainText || typeof plainText !== "string") {
    return [];
  }

  // Split the text by newlines
  const paragraphs = plainText.split("\n").filter((p) => p.trim() !== "");

  return paragraphs.map((paragraph) => {
    // Check if this paragraph is a header (starts with ### or ## or #)
    if (paragraph.startsWith("####")) {
      return {
        _type: "block",
        style: "h4",
        children: [
          {
            _type: "span",
            text: paragraph.replace(/^#+\s*/, ""),
            marks: [], // Look for bold/italic markers
          },
        ],
      };
    } else if (paragraph.startsWith("###")) {
      return {
        _type: "block",
        style: "h3",
        children: [
          {
            _type: "span",
            text: paragraph.replace(/^#+\s*/, ""),
            marks: [],
          },
        ],
      };
    } else if (paragraph.startsWith("##")) {
      return {
        _type: "block",
        style: "h2",
        children: [
          {
            _type: "span",
            text: paragraph.replace(/^#+\s*/, ""),
            marks: [],
          },
        ],
      };
    } else if (paragraph.startsWith("#")) {
      return {
        _type: "block",
        style: "h1",
        children: [
          {
            _type: "span",
            text: paragraph.replace(/^#+\s*/, ""),
            marks: [],
          },
        ],
      };
    } else {
      // Handle bold text (**text**)
      const spans = [];
      let currentText = paragraph;
      let lastIndex = 0;

      // Find all **bold** text patterns
      const boldRegex = /\*\*(.*?)\*\*/g;
      let match;

      while ((match = boldRegex.exec(currentText)) !== null) {
        // Add text before the bold section
        if (match.index > lastIndex) {
          spans.push({
            _type: "span",
            text: currentText.substring(lastIndex, match.index),
            marks: [],
          });
        }

        // Add the bold text
        spans.push({
          _type: "span",
          text: match[1],
          marks: ["strong"],
        });

        lastIndex = match.index + match[0].length;
      }

      // Add remaining text after the last bold section
      if (lastIndex < currentText.length) {
        spans.push({
          _type: "span",
          text: currentText.substring(lastIndex),
          marks: [],
        });
      }

      return {
        _type: "block",
        style: "normal",
        children: spans,
      };
    }
  });
};

// Fonction pour formater les donnÃ©es de la page About pour correspondre Ã  l'ancienne structure Sanity
export const formatAboutPageData = (strapiData) => {
  if (!strapiData) {
    return null;
  }

  const attributes = strapiData.attributes || strapiData;

  return {
    id: strapiData.id,
    description: convertPlainTextToPortableText(attributes.description) || [], // Convert to PortableText format
    hero: {
      title: attributes.hero?.title || "",
      description: attributes.hero?.description || "",
      image: attributes.hero?.image?.data?.attributes?.url
        ? `${getStrapiBaseUrl()}${attributes.hero.image.data.attributes.url}`
        : "",
    },
    statsBlock:
      attributes.statsBlock?.data?.map((stat) => ({
        id: stat.id,
        value: stat.value || "",
        title: stat.title || "",
      })) || [],
  };
};
